// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 15:08:15
import * as SagaBase from '../../../SagaBase';
import { Guid, GuidTools } from '@models/guid';
import { BaseObject } from '@models/BaseObject';

export abstract class SaveProcedureResultArgs_abstract extends BaseObject {
  static $t: string = 'SagaBase.Defines.SaveProcedureResultArgs';
  $t: string = 'SagaBase.Defines.SaveProcedureResultArgs';

  public static GetMembers(): string[] {
    return ['ProcedureID', 'Error'];
  }

  public GetMembers(): string[] {
    return SaveProcedureResultArgs_abstract.GetMembers();
  }

  public _init(): void {
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/
    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public ProcedureID: number = 0;
  public Error: SagaBase.ServerErrorType = SagaBase.ServerErrorType.None;

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  /*</AUTO_IMPLEMENTATION>*/
}
